// test1623
(1623 && 0);
